
export default {
  props: {
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};